import { useState } from "react";
import { Link } from "react-router-dom";

// Less is more: one idea per step, one or two short lines each. No decorative art.
const STEPS = [
  {
    title: "Start with your Relay Target",
    body: "Run the Relay Calculator first. It turns your expenses, taxes, savings, debt, and PTO goals into one clear weekly number.",
  },
  {
    title: "One week = one relay",
    body: "This screen shows what's left to earn this relay and a box to log today's income. That's the whole daily habit.",
  },
  {
    title: "Red, black, green",
    body: "The big number starts red, turns black when you clear your target, and green when you earn past it.",
  },
  {
    title: "Your daily target adjusts",
    body: "What's left is split across your remaining work days. Log a win or tag a day off and tomorrow's number updates itself.",
  },
  {
    title: "Everything else is in the menu",
    body: "Scoreboard, Time Off, Resources, your sheet, and settings live in the menu, come back to them when you need them.",
  },
  {
    title: "Help prove this works",
    body: "In Settings you can switch on research contribution. It's the only way we can show that a weekly finish line really does help independent earners earn steadier, set money aside and take real time off. Anonymous: no name, no email, no exact figures, only ranges.",
    cta: { to: "/app/settings", label: "Open Settings" },
  },
];

export const CaddyTour = ({ onDone }) => {
  const [i, setI] = useState(0);
  const step = STEPS[i];
  const last = i === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-6" style={{ background: "rgba(42,30,92,0.55)", backdropFilter: "blur(6px)" }} data-testid="caddy-tour">
      <div className="w-full max-w-sm rounded-3xl p-7 text-center" style={{ background: "var(--pr-bg)" }}>
        <p className="text-[10px] font-bold uppercase tracking-widest mb-5" style={{ color: "var(--pr-muted)" }}>
          How to Get Set for Success · {i + 1} of {STEPS.length}
        </p>
        <h2 className="text-2xl mb-3" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "var(--pr-ink)" }} data-testid="caddy-tour-title">
          {step.title}
        </h2>
        <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--pr-ink2)" }}>{step.body}</p>
        {step.cta && (
          <Link
            to={step.cta.to}
            onClick={onDone}
            className="inline-block mb-5 text-sm font-bold underline underline-offset-4"
            style={{ color: "#2A1E5C" }}
            data-testid="caddy-tour-cta"
          >
            {step.cta.label}
          </Link>
        )}
        <div className="mb-2" />

        <div className="flex items-center justify-center gap-2 mb-6">
          {STEPS.map((_, d) => (
            <span
              key={d}
              className="rounded-full transition-all"
              style={{
                width: d === i ? 22 : 8,
                height: 8,
                background: d === i ? "#2A1E5C" : "var(--pr-card-line)",
              }}
              data-testid={`caddy-tour-dot-${d}`}
            />
          ))}
        </div>

        <div className="flex gap-2">
          {i > 0 && (
            <button
              onClick={() => setI(i - 1)}
              className="px-5 py-3.5 rounded-full font-bold text-sm border"
              style={{ borderColor: "var(--pr-card-line)", color: "var(--pr-ink2)", background: "var(--pr-card)" }}
              data-testid="caddy-tour-back"
            >
              ← Back
            </button>
          )}
          <button
            onClick={() => (last ? onDone() : setI(i + 1))}
            className="flex-1 py-3.5 rounded-full font-bold text-base transition-transform hover:scale-[1.02]"
            style={{ background: "#2A1E5C", color: "#fff" }}
            data-testid={last ? "caddy-tour-done" : "caddy-tour-next"}
          >
            {last ? "Start racing" : "Next →"}
          </button>
        </div>
        {!last && (
          <button onClick={onDone} className="mt-3 text-xs underline" style={{ color: "var(--pr-muted)" }} data-testid="caddy-tour-skip">
            Skip for now
          </button>
        )}
      </div>
    </div>
  );
};
